import { EditorState } from 'prosemirror-state'

export const getCharBeforeCursor = (state: EditorState) => {
  const { nodeBefore } = state.selection.$anchor
  if (nodeBefore && nodeBefore.text) {
    return nodeBefore.text.charAt(nodeBefore.text.length - 1)
  }
}

export const getCharBeforePosition = (state: EditorState, pos: number) => {
  const res = state.doc.resolve(pos)
  const { nodeBefore } = res
  if (nodeBefore && nodeBefore.text) {
    return nodeBefore.text.charAt(nodeBefore.text.length - 1)
  }
}
